import { FaBook, FaFilePdf } from "react-icons/fa"
import { Link } from "@tanstack/react-router"
import type { Document } from "@apps/gwservice/types"
import { attachmentUrl } from "~/lib/attachment-url"

function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

interface AttachmentBlockProps {
  document: Document
}

const cardClassName = "flex items-center gap-m p-s border border-border rounded-lg hover:bg-muted/50 transition-colors"

function CardContent({ document, size }: { document: Document; size: string }) {
  const Icon = document.mimeType === "application/pdf" ? FaFilePdf : FaBook
  return (
    <>
      <div className="shrink-0 flex flex-col items-center gap-s">
        <Icon className="text-2xl text-primary" />
        <div className="text-xs text-muted-foreground">{size}</div>
      </div>
      <div className="flex flex-col justify-between gap-xs">
        <div className="font-medium leading-tight line-clamp-2 hyphens-auto" lang="ru">{document.title}</div>
        {document.author && <p className="text-muted-foreground truncate">{document.author}</p>}
      </div>
    </>
  )
}

export function AttachmentBlock({ document }: AttachmentBlockProps) {
  const url = attachmentUrl(document.url)
  const size = formatFileSize(document.filesize)

  if (document.mimeType === "application/epub+zip") {
    return (
      <Link
        to="/document/$id"
        params={{ id: String(document.id) }}
        className={cardClassName}
      >
        <CardContent document={document} size={size} />
      </Link>
    )
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={cardClassName}
    >
      <CardContent document={document} size={size} />
    </a>
  )
}
